// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2arJT","label":"styles_label__3Dl90"};